export default __webpack_public_path__ + "static/media/toggleTrendDataActiveIcon.4d8f4b22.svg";